import mainSignatoryMocks from './main-signatory';
import signatoryMocks from './signatory';
import occupantMocks from './occupant';
import parametersMocks from './parameters';
import dossierMocks from './dossier-read';
import stepMocks from './step-write';
import consentsGroupMocks from './consents-group-update-status';
import userMock from '@isyc-react/oc-api/mocks/apollo/user-read';
// const autologin = process.env.autologin === 'true'
export default [...userMock, ...mainSignatoryMocks, ...signatoryMocks, ...occupantMocks, ...parametersMocks, ...dossierMocks, ...stepMocks, ...consentsGroupMocks];
